module.exports = __webpack_public_path__ + "static/project-5c-31f746c2fe4bb57c2ca76c0395bde675.png";